import { MgPrisFeature } from '@retail/mgpris/config-types';
import { useMemo } from 'react';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { isFeatureEnabled } from '@retail/utils';
import { useSelectedOrgUnit } from '../SelectedOrgUnit';

export const useIsFeatureEnabled = (featureName: MgPrisFeature) => {
  const { featureFlags } = useMgPrisConfig();
  const { orgUnitType, appTenant } = useSelectedOrgUnit();

  return useMemo(
    () =>
      isFeatureEnabled({
        features: featureFlags,
        name: featureName,
        orgUnitType,
        country: appTenant.countryCode,
      }),
    [featureFlags, featureName, orgUnitType, appTenant.countryCode]
  );
};
